import { Box, Dropdown, DropdownOption } from "@modernatx-internal/ui-kit-react";
import { useRouter } from "next/router";
import React from "react";

import { useExperience } from "@/hooks/useExperience";
import { useLocalizedPath } from "@/hooks/useLocalizedPath";
import { useText } from "@/hooks/useText";

export const LanguageSelector: React.FC = () => {
  const { pathCountry, pathLanguage } = useExperience();
  const { replace } = useRouter();
  const { getLocalizedPath } = useLocalizedPath();
  const { getText } = useText();
  const [languageSelected, languageSelectedSet] = React.useState<DropdownOption | undefined>(
    pathLanguage
      ? {
          label: pathLanguage.native,
          value: String(pathLanguage.iso2)
        }
      : undefined
  );
  const languagesSorted = React.useMemo(() => {
    const languages = pathCountry ? [...pathCountry.languages] : [];
    return languages.sort((prev, next) => prev.native.localeCompare(next.native));
  }, [pathCountry]);

  const handleLanguageSelect = React.useCallback(
    (optionNext: DropdownOption) => {
      replace(getLocalizedPath(`/${pathCountry?.iso2.toLowerCase()}/${optionNext.value}`, false));
    },
    [getLocalizedPath, pathCountry, replace]
  );

  if (!pathCountry || !pathLanguage || pathCountry.languages.length < 2) {
    return null;
  }

  if (pathLanguage.iso2 !== languageSelected?.value) {
    languageSelectedSet({
      label: pathLanguage.native,
      value: String(pathLanguage.iso2)
    });
  }

  return (
    <Box
      sx={{
        minWidth: 34,
        // @ts-ignore
        "@media print": {
          display: "none"
        }
      }}
    >
      <Dropdown
        label={getText("LANGUAGE")}
        dropdownOptions={languagesSorted.map((languageOption) => ({
          label: languageOption.native,
          value: String(languageOption.iso2)
        }))}
        onSelectOption={handleLanguageSelect}
        selectedOption={languageSelected}
      />
    </Box>
  );
};
